import { render, staticRenderFns } from "./Universitas.vue?vue&type=template&id=df8f9744&"
import script from "./Universitas.vue?vue&type=script&lang=js&"
export * from "./Universitas.vue?vue&type=script&lang=js&"
import style0 from "./Universitas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports